import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { NurseProfilesInfoByRegistryController } from '../../models/actor/actor';


@Pipe({
  name: 'NurseProfilesInfoByRegistry'
})

@Injectable()
export class NurseProfilesInfoByRegistryPipe implements PipeTransform {

  transform(value: NurseProfilesInfoByRegistryController[], filter: string): NurseProfilesInfoByRegistryController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: NurseProfilesInfoByRegistryController) =>
      app.NurseDisplayName != null && app.NurseDisplayName.toLocaleLowerCase().indexOf(filter) != -1
      || app.NurseUserName != null && app.NurseUserName.toLocaleLowerCase().indexOf(filter) != -1

     // || app.AcceptedOn != null && app.AcceptedOn.toDateString().toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }

}
